/**
 * Created by mariushirjanu on 21/09/2020.
 */
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IObject } from '../../../../type_definitions/datatypes';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { EVENT_ORDER_CONTEXT_UPDATED } from '../../../shared/app-events';

@Component({
  selector: 'shipping-info',
  template: `
    <shipping-details [shopContext]="shopContext"></shipping-details>
  `
})
export class ShippingInfoComponent implements OnInit {
  @Input() public shopContext:IObject;
  private eventHandler:Subscription;

  constructor(
    private gaEventService:GaEventService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.gaEventService.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_ORDER_CONTEXT_UPDATED) {
        this.shopContext = event.data;
      }
    });
  }

  public ngOnDestroy():void {
    this.eventHandler.unsubscribe();
  }
}